import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IChatService,
  ISendChatMessageUseCase,
  SendChatMessageUseCaseInput,
  SendChatMessageUseCaseOutput,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class SendChatMessageInteractor implements ISendChatMessageUseCase {
  @inject(symbols.IChatService) private chatService: IChatService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  handle(input: SendChatMessageUseCaseInput): SendChatMessageUseCaseOutput {
    const output = this.getDefaultOutputData()
    try {
      this.chatService.sendChatMessage(input)
      output.isSuccessful = true
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): SendChatMessageUseCaseOutput {
    return {
      isSuccessful: false,
      error: null,
    }
  }
}
